var _effectorFileName = "/src/page-content/cases/model.ts";
import { pagesPath } from '@/shared/config/$path';
import { declarePage } from '@/shared/lib/effector/page';
export const casesPage = declarePage({
  pageType: pagesPath.$url().pathname
});